export const TripAction = {
    LOAD: 'LOAD',
    LOAD_DETAIL: 'LOAD_DETAIL',
    UPDATE: 'UPDATE',
    PUBLISH: 'PUBLISH',
    UNPUBLISH: 'UNPUBLISH',
    APPLY_TRANSITION: 'APPLY_TRANSITION',
    SET_ACTIVE_VARIANT: 'SET_ACTIVE_VARIANT',
};

export const TripMutation = {
    REQUEST: 'REQUEST',
    SUCCESS: 'SUCCESS',
    UPDATE_REQUEST: 'UPDATE_REQUEST',
    SUCCESS_DETAIL: 'SUCCESS_DETAIL',
    SUCCESS_UPDATE: 'SUCCESS_UPDATE',
    ERROR: 'ERROR',
    ERROR_UPDATE: 'ERROR_UPDATE',
    SET_ACTIVE_VARIANT: 'SET_ACTIVE_VARIANT',
};
